import { css } from "styled-components";

export const ScrollbarStyles = css`
    ::-webkit-scrollbar-thumb {
        display: block;
        border-radius: 10px;
        background-color: ${(props) => props.theme.controlPrimary};
        border: 3px ${(props) => props.theme.backgroundPrimary} solid;
    }

    ::-webkit-scrollbar {
        display: block;
        width: 11px;
    }

    ::-webkit-resizer {
        display: none;
    }
`;
